<template>
  <FormModal
    title="Quel type d'isolation est déjà présent dans la maison?"
    show-back-btn
  >
    <template #body>
      <TypeOfInsulationFormStep :progress-value="progressValue" />
    </template>
  </FormModal>
</template>

<script>
import FormModal from 'chimera/all/themes/blueflow/components/layout/FormModal'
import AbstractFormPage from 'chimera/all/components/page/AbstractFormPage'
import TypeOfInsulationFormStep from '~/components/form/steps/typeOfInsulation/TypeOfInsulationFormStep'

export default {
  components: {
    TypeOfInsulationFormStep,
    FormModal,
  },

  extends: AbstractFormPage,

  layout: 'form',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: "Type d'isolation",
      headDescription: "Indiquez quel type d'isolation vous recherchez.",
      path: '/quotes-requests/type-disolement',
      progressValue: 30,
      checkoutStep: 2,
    }
  },
}
</script>
